import React from "react";
import TransactionDataHandler from "../Components/TransactionDataHandler";

function Index() {
	return <TransactionDataHandler />;
}
export default Index;
